export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жол"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["дейін"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["символдар"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рұқсат етілмеген мән"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Міндетті өріс"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Өрістерді тексеріңіз"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Макс."])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SVG, PNG немесе JPG"])}
}